import { useEffect, useState } from "react";

const categories = [
  "Haircut",
  "Coffee",
  "Car Repair",
  "Pizza",
  "Fitness",
];

const dealButtons = [
  "50% Off",
  "BOGO",
  "Save $10",
  "Earn 800 Points",
  "Flash Sale",
  "2 For 1",
];

export default function DealsCategoryBannerSection() {

  const [itemHeight, setItemHeight] = useState(60);

useEffect(() => {
  const updateHeight = () => {
    const w = window.innerWidth;
    if (w >= 1850) setItemHeight(120);
    else if (w >= 1199) setItemHeight(75);
    else setItemHeight(60);
  };

  updateHeight();
  window.addEventListener('resize', updateHeight);
  return () => window.removeEventListener('resize', updateHeight);
}, []);

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(prev => (prev + 1) % categories.length);
    }, 2600);

    return () => clearInterval(interval);
  }, []);

    const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % categories.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);


  return (
    <div>
      <div className="hidden lg:block px-6">
      <section className="w-full flex justify-center mt-[80px]">

      <div className="
        relative
        w-full
        max-w-[1700px]
        h-[470px]
        rounded-[32px]
        overflow-hidden
        bg-gradient-to-r
        from-[#c40000]
        via-[#ff0000]
        to-[#990000]
        shadow-[0px_40px_120px_rgba(0,0,0,0.18)]
      ">

        {/* background waves */}
        <img
          src="/images/group.png"
          className="absolute inset-0 w-full h-full object-cover opacity-90"
        />

        <img
          src="/images/svgid-00000000901794113707704080000001301560331484438934.png"
          className="absolute inset-0 w-full h-full object-cover opacity-40"
        />

        <img
          src="/images/ellipse-1585.svg"
          className="absolute bottom-[-40px] left-1/2 -translate-x-1/2 w-[1000px] opacity-60"
        />

        {/* CONTENT */}
        <div className="relative z-10 flex flex-col items-center justify-center h-full">

          {/* badge */}
          <div className="
            flex items-center gap-2
            bg-white
            rounded-full
            px-5
            py-2
            shadow-md
            mb-6
          ">
            <span className="text-red-600 text-sm">★</span>
            <span className="text-gray-800 text-sm font-medium">
              Over 50 Categories
            </span>
          </div>


          {/* heading */}
          <h2 className="
            text-white
            text-[45px]
            lg:text-[40px]
            font-medium
            leading-tight
          ">
            Discover New Deals Every Day
          </h2>


          {/* animated category */}
          <div className="
            relative
            h-[72px]
            mt-2
            flex
            items-center
            justify-center
            overflow-visible
          ">

           <div className="overflow-hidden  h-[60px] min-[1199px]:h-[75px] min-[1850px]:h-[120px] p">
  <div
    className="transition-transform duration-500"
    style={{ transform: `translateY(-${currentIndex * itemHeight}px)` }}
  >
    {categories.map((text, index) => (
       <div
        key={index}
        className="font-semibold text-white text-center to-red-700 bg-clip-text "
        style={{
          fontSize: 'clamp(56px, calc(56px + (82 - 56) * ((100vw - 1199px) / (1850 - 1199))), 82px)',
          lineHeight: itemHeight + 'px',
        }}
      >
        {text}
      </div>
    ))}
  </div>
</div>

          </div>


          {/* subtext */}
          <p className="text-white/90 mt-3 text-[16px]">
            And thousands more deals across every category imaginable.
          </p>


          {/* ticket badge */}
          <div  className="w-full  mt-12">

            <div aria-hidden="true" className="flex gap-5 animate-marquee-discover">

              {[...dealButtons, ...dealButtons, ...dealButtons, ...dealButtons ].map((label, i) => (

                <div key={i} className="ticket">
                  {label}
                </div>

              ))}

            </div>

          </div>

        </div>


        {/* STYLES */}
        <style>{`

          /* WORD ANIMATION */
          @keyframes wordAnimation {
          --s: 140px; /* size of the logo */
  --d: 13s; /* animation duration*/
  --n: 4; /* number of visible logos */
            0% {
              opacity:0;
              transform: translateY(40px);
            }

            15% {
              opacity:1;
              transform: translateY(0);
            }

            85% {
              opacity:1;
              transform: translateY(0);
            }

            100% {
              opacity:0;
              transform: translateY(-40px);
            }

          }

          .animate-word {
            animation: wordAnimation 2.6s ease;
          }


          /* MARQUEE */
          @keyframes marquee {
            from {
              transform: translateX(0);
            }
            to {
              transform: translateX(-50%);
            }
          }

          .animate-marquee {
            width:max-content;
            animation: marquee 28s linear infinite;
          }
            
          .animate-marquee-reverse {
            width:max-content;
            animation: marquee 10s linear infinite;
            animation-direction: reverse;
          }

          // .animate-marquee-reverse {
          //   width:max-content;
          //   animation: marquee 10s linear infinite;
          //   animation-direction: reverse;
          // }


          /* FIGMA TICKET STYLE BADGE */
          .ticket {

            position: relative;
            padding: 12px 28px;

            color:white;
            font-weight:500;
            font-size:15px;

            background: rgba(255,255,255,0.25);

            backdrop-filter: blur(10px);

            border: 1px solid rgba(255,255,255,0.35);

            clip-path: polygon(
              10px 0,
              calc(100% - 10px) 0,
              100% 10px,
              100% calc(100% - 10px),
              calc(100% - 10px) 100%,
              10px 100%,
              0 calc(100% - 10px),
              0 10px
            );

            box-shadow:
              0 8px 20px rgba(0,0,0,0.18);

            white-space:nowrap;
          }

        `}</style>

      </div>

    </section>
    </div>

    <div className="block lg:hidden">
      <section className="w-full flex justify-center ">

      <div className="
        relative
        w-full
        max-w-[1700px]
        h-[400px]
        
        overflow-hidden
        bg-gradient-to-r
        from-[#c40000]
        via-[#ff0000]
        to-[#990000]
        shadow-[0px_40px_120px_rgba(0,0,0,0.18)]
      ">

        {/* background waves */}
        <img
          src="/images/group.png"
          className="absolute inset-0 w-full h-full object-cover opacity-90"
        />

        <img
          src="/images/svgid-00000000901794113707704080000001301560331484438934.png"
          className="absolute inset-0 w-full h-full object-cover opacity-40"
        />

        <img
          src="/images/ellipse-1585.svg"
          className="absolute bottom-[-40px] left-1/2 -translate-x-1/2 w-[1000px] opacity-60"
        />

        {/* CONTENT */}
        <div className="relative z-10 flex flex-col items-center justify-center h-full">

          {/* badge */}
          <div className="
            flex items-center gap-2
            bg-white
            rounded-full
            px-5
            py-2
            shadow-md
            mb-6
          ">
            <span className="text-red-600 text-sm">★</span>
            <span className="text-gray-800 text-sm font-medium">
              Over 50 Categories
            </span>
          </div>


          {/* heading */}
          <h2 className="
            text-white
            text-[24px]
            lg:text-[52px]
            font-medium
            leading-tight
          ">
            Discover New Deals Every Day
          </h2>


          {/* animated category */}
          <div className="
            relative
            h-[72px]
            mt-2
            flex
            items-center
            justify-center
            overflow-visible
          ">

           <div className="overflow-hidden  h-[60px] min-[1199px]:h-[75px] min-[1850px]:h-[120px] p">
  <div
    className="transition-transform duration-500"
    style={{ transform: `translateY(-${currentIndex * itemHeight}px)` }}
  >
    {categories.map((text, index) => (
       <div
        key={index}
        className="font-semibold text-white text-center to-red-700 bg-clip-text "
        style={{
          fontSize: 'clamp(56px, calc(56px + (82 - 56) * ((100vw - 1199px) / (1850 - 1199))), 82px)',
          lineHeight: itemHeight + 'px',
        }}
      >
        {text}
      </div>
    ))}
  </div>
</div>

          </div>


          {/* subtext */}
          <p className="text-white/90 mt-3 text-[16px] text-center px-3">
            and thousands more deals across every category imaginable.
          </p>


          {/* ticket badge */}
          <div className="w-full overflow-hidden mt-12">

            <div className="flex gap-5 animate-marquee">

              {[...dealButtons, ...dealButtons].map((label, i) => (

                <div key={i} className="ticket">
                  {label}
                </div>

              ))}

            </div>

          </div>

        </div>


        {/* STYLES */}
        <style>{`

          /* WORD ANIMATION */
          @keyframes wordAnimation {
          --s: 140px; /* size of the logo */
  --d: 13s; /* animation duration*/
  --n: 4; /* number of visible logos */
            0% {
              opacity:0;
              transform: translateY(40px);
            }

            15% {
              opacity:1;
              transform: translateY(0);
            }

            85% {
              opacity:1;
              transform: translateY(0);
            }

            100% {
              opacity:0;
              transform: translateY(-40px);
            }

          }

          .animate-word {
            animation: wordAnimation 2.6s ease;
          }


          /* MARQUEE */
          @keyframes marquee {
            from {
              transform: translateX(0);
            }
            to {
              transform: translateX(-50%);
            }
          }

          .animate-marquee {
            width:max-content;
            animation: marquee 28s linear infinite;
          }
            .animate-marquee-discover {
            width:max-content;
            animation: marquee 18s linear infinite;
          }
            
          .animate-marquee-reverse {
            width:max-content;
            animation: marquee 25s linear infinite;
            animation-direction: reverse;
          }

          


          /* FIGMA TICKET STYLE BADGE */
          .ticket {

            position: relative;
            padding: 12px 28px;

            color:white;
            font-weight:500;
            font-size:15px;

            background: rgba(255,255,255,0.25);

            backdrop-filter: blur(10px);

            border: 1px solid rgba(255,255,255,0.35);

            clip-path: polygon(
              10px 0,
              calc(100% - 10px) 0,
              100% 10px,
              100% calc(100% - 10px),
              calc(100% - 10px) 100%,
              10px 100%,
              0 calc(100% - 10px),
              0 10px
            );

            box-shadow:
              0 8px 20px rgba(0,0,0,0.18);

            white-space:nowrap;
          }

        `}</style>

      </div>

    </section>
    </div>
    </div>
    
  );
}